import classNames from "classnames";
import styles from "./stepper.module.scss";

const Stepper = ({
  noOfSteps,
  titles,
  currentStep,
}: {
  noOfSteps: number;
  titles: string[];
  currentStep: number;
}) => {
  return (
    <section className={styles.steps}>
      {Array.from({ length: noOfSteps }, (_, index) => (
        <div key={index} className={styles.step}>
          <div className={styles.flex}>
            {index !== 0 ? (
              <span
                className={classNames(
                  styles.stepLine,
                  index !== 0 && index + 1 <= currentStep
                    ? styles.invisible
                    : ""
                )}
              ></span>
            ) : null}
            <span
              className={classNames(
                currentStep >= index + 1
                  ? styles.stepCircle
                  : styles.greyStepCircle,
                currentStep > index + 1 ? styles.done : ""
              )}
            >
              {index + 1}
            </span>
          </div>
          <span
            className={classNames(
              currentStep < index + 1 ? styles.notReached : "",
              styles.responsiveLg
            )}
          >
            {titles[index]}
          </span>
        </div>
      ))}
    </section>
  );
};

export default Stepper;
